var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _c(
        "el-scrollbar",
        {
          staticStyle: { height: "calc(100% - 50px)" },
          attrs: { "wrap-class": "scrollbar-wrapper" }
        },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenuIndex,
                "default-openeds": [_vm.activeMenuIndex],
                collapse: _vm.isCollapse,
                "background-color": _vm.menuBg,
                "text-color": _vm.variables.menuText,
                "active-text-color": _vm.variables.menuActiveText,
                "collapse-transition": false,
                "unique-opened": true,
                mode: "vertical"
              },
              on: {
                open: function($event) {
                  return _vm.toggleSubMenu(true, $event)
                },
                close: function($event) {
                  return _vm.toggleSubMenu(false, $event)
                }
              }
            },
            _vm._l(_vm.curRouteMenus, function(route, index) {
              return _c("sidebar-item", {
                key: route.path + index,
                attrs: {
                  item: route,
                  "current-menu": _vm.currentMenu,
                  "base-path": route.path
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "siderbar-arrow",
          class: { arrowLeft: _vm.isCollapse },
          on: { click: _vm.toggleSideBar }
        },
        [
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isCollapse,
                expression: "!isCollapse"
              }
            ],
            staticClass: "el-icon-arrow-left"
          }),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isCollapse,
                expression: "isCollapse"
              }
            ],
            staticClass: "el-icon-arrow-right"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }